import { useState, useEffect } from 'react';
import { getStudentsLAB } from '../../redux/api/subjects';
import { useSnackbar } from 'react-simple-snackbar';
import { optionsStyle } from '../../utils/snackStyles';

const useStudentsCourseLAB = (assignmentId) => {
    const [openSnackbar] = useSnackbar(optionsStyle);
    const [students, setStudents] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        if (assignmentId) {
            fetchStudents();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [assignmentId]);

    const fetchStudents = async () => {
        setStudents(null);
        const request = await getStudentsLAB(assignmentId);

        if (request.error) {
            openSnackbar('¡No se pudieron cargar los estudiantes LAB!');
            setStudents(false);
        } else {
            const data = request.data?.[0] || [];
            setStudents(data);
        }
    };

    const filteredStudents =
        students && searchQuery
            ? students.filter((student) =>
                  student.name.toLowerCase().includes(searchQuery.toLowerCase())
              )
            : students;

    return {
        students: filteredStudents,
        allStudents: students,
        searchQuery,
        setSearchQuery,
    };
};

export default useStudentsCourseLAB;
